export const reportRegisterationAnalytics = (content_name) => {
  sendGoogleAnalyticsRegisterationEvent(content_name);
  sendFacebookPixelRegisterationEvent(content_name);
}

export const sendGoogleAnalyticsRegisterationEvent = (content_name) => {
  if (process.env.NODE_ENV === 'production'){
    gtag('event', 'sign_up', {
      event_label: content_name,
    });
  }
}

export const sendFacebookPixelRegisterationEvent = (content_name) => {
  if (process.env.NODE_ENV === 'production') {
    fbq('track', 'CompleteRegistration', {
      currency: 'USD',
      value: 0.5,
      content_name: content_name
    });
  }
}




// WEBPACK FOOTER //
// ./app/containers/Auth/Helpers/actions.js